// M04 角、平行線、三角形與四邊形 - 主題 01-05 數據文件
// Angles, Parallel Lines, Triangles and Quadrilaterals - Topics 01-05
// 系統化設計，準備後續 Supabase 數據遷移

// M04-01: 平行線角度關係 (Parallel Lines Angle Relationships)
export const M04_01_PROBLEMS = [
  {
    id: "M04_01_001",
    topicId: "M04_01",
    question: "如圖，AB ∥ CD，EF 為橫截線，∠1 = 65°。\n(a) 求∠2的度數（同位角）\n(b) 求∠3的度數（內錯角）\n(c) 證明∠1 + ∠4 = 180°（同側內角）",
    solution: "(a) ∠2 = 65°, (b) ∠3 = 65°, (c) ∠1 + ∠4 = 65° + 115° = 180°",
    explanation: "平行線的性質：同位角相等，內錯角相等，同側內角互補。",
    hint: "記住平行線被橫截線所截的三個重要性質。",
    difficulty: 1,
    order: 1,
    steps: [
      "(a) ∠1 和 ∠2 是同位角，AB ∥ CD，所以 ∠2 = ∠1 = 65°",
      "(b) ∠1 和 ∠3 是內錯角，AB ∥ CD，所以 ∠3 = ∠1 = 65°",
      "(c) ∠1 和 ∠4 是同側內角，AB ∥ CD，所以 ∠1 + ∠4 = 180°",
      "因此 ∠4 = 180° - 65° = 115°，得證"
    ]
  },
  {
    id: "M04_01_002",
    topicId: "M04_01",
    question: "在平行線 PQ ∥ RS 中，橫截線 TU 與它們相交。\n(a) 若∠PTU = 3x + 20°，∠TUR = 2x + 35°，且它們是內錯角，求 x 的值\n(b) 求∠PTU 的度數\n(c) 求與∠PTU 相鄰的同側內角度數",
    solution: "(a) x = 25°, (b) ∠PTU = 95°, (c) 同側內角 = 85°",
    explanation: "內錯角相等的性質建立方程，解出x後計算各角度數。",
    hint: "內錯角相等，同側內角互補。",
    difficulty: 2,
    order: 2,
    steps: [
      "(a) 內錯角相等：3x + 20° = 2x + 35°",
      "解方程：3x - 2x = 35° - 20°",
      "x = 15°",
      "(b) ∠PTU = 3(15°) + 20° = 65°",
      "(c) 同側內角 = 180° - 65° = 115°"
    ]
  },
  {
    id: "M04_01_003",
    topicId: "M04_01",
    question: "已知直線 AB ∥ CD，點 E 在 AB 上，點 F 在 CD 上，點 G 在 AB 和 CD 之間。\n(a) 若∠AEG = 40°，∠GFD = 70°，求∠EGF\n(b) 證明∠EGF = ∠AEG + ∠GFD\n(c) 這個結果說明了什麼幾何定理？",
    solution: "(a) ∠EGF = 110°, (b) 見證明, (c) 三角形外角定理的推廣",
    explanation: "利用平行線性質和三角形內角和定理進行證明。",
    hint: "延長線段，利用平行線性質轉換角度關係。",
    difficulty: 3,
    order: 3,
    steps: [
      "(a) 延長 GE 交 CD 於點 H",
      "∠AEG = ∠EHF = 40°（內錯角）",
      "在△GHF 中，∠HGF = 180° - ∠EHF - ∠GFD = 180° - 40° - 70° = 70°",
      "∠EGF = 180° - ∠HGF = 180° - 70° = 110°",
      "(b) 證明：∠EGF = 40° + 70° = ∠AEG + ∠GFD",
      "(c) 這說明了平行線間任意點與平行線上兩點形成的角等於兩個同側角之和"
    ]
  },
  {
    id: "M04_01_004",
    topicId: "M04_01",
    question: "三條平行線 l₁ ∥ l₂ ∥ l₃，橫截線 m 和 n 分別與它們相交。\n(a) 若橫截線 m 上對應線段比為 2:3，求橫截線 n 上對應線段的比\n(b) 若 l₁l₂ = 4cm，l₂l₃ = 6cm，橫截線 n 上 A₁A₂ = 6cm，求 A₂A₃\n(c) 證明平行線分線段成比例定理",
    solution: "(a) 2:3, (b) A₂A₃ = 9cm, (c) 見證明",
    explanation: "平行線分線段成比例是重要的幾何定理。",
    hint: "平行線被兩條橫截線所截，對應線段成比例。",
    difficulty: 3,
    order: 4,
    steps: [
      "(a) 平行線分線段成比例，所以比例相同：2:3",
      "(b) 設置比例：4:6 = 6:A₂A₃",
      "4 × A₂A₃ = 6 × 6",
      "A₂A₃ = 36/4 = 9cm",
      "(c) 證明基於相似三角形的性質",
      "對應邊成比例是平行線的重要性質"
    ]
  },
  {
    id: "M04_01_005",
    topicId: "M04_01",
    question: "在梯形 ABCD 中，AB ∥ CD，對角線 AC 和 BD 相交於點 O。\n(a) 證明△AOB ∽ △COD\n(b) 若 AB = 8cm，CD = 12cm，求 AO:OC 的比值\n(c) 求△AOB 與△COD 的面積比",
    solution: "(a) 見證明, (b) AO:OC = 2:3, (c) 面積比 = 4:9",
    explanation: "梯形中平行線產生的相似三角形性質。",
    hint: "利用平行線產生的角相等來證明三角形相似。",
    difficulty: 4,
    order: 5,
    steps: [
      "(a) ∵ AB ∥ CD，∴ ∠BAO = ∠DCO（內錯角）",
      "∠ABO = ∠CDO（內錯角）",
      "∠AOB = ∠COD（對頂角）",
      "∴ △AOB ∽ △COD",
      "(b) 相似三角形對應邊成比例：AO:OC = AB:CD = 8:12 = 2:3",
      "(c) 相似三角形面積比等於對應邊比的平方：(2/3)² = 4/9"
    ]
  },
  {
    id: "M04_01_006",
    topicId: "M04_01",
    question: "設計一個平行線系統：三條平行線 a、b、c，其中 a 和 b 的距離為 3cm，b 和 c 的距離為 5cm。\n(a) 若橫截線與 a、b、c 分別交於點 A、B、C，且∠BAC = 30°，求∠ABC\n(b) 計算從點 A 到直線 c 的距離\n(c) 設計一個實際應用場景來說明這個幾何關係",
    solution: "(a) ∠ABC = 150°, (b) 距離 = 8cm, (c) 見應用場景",
    explanation: "綜合運用平行線性質解決實際幾何問題。",
    hint: "結合平行線距離和角度關係進行綜合計算。",
    difficulty: 4,
    order: 6,
    steps: [
      "(a) 作 AD ⊥ a，BE ⊥ b，CF ⊥ c",
      "由平行線性質，∠BAD = ∠ABC（同位角）",
      "在直角三角形中計算：∠ABC = 180° - 30° = 150°",
      "(b) A 到 c 的距離 = a 到 b 的距離 + b 到 c 的距離 = 3 + 5 = 8cm",
      "(c) 應用場景：建築中的平行樓層設計",
      "或道路工程中的平行車道規劃"
    ]
  }
];

// M04-02: 角度性質證明 (Angle Properties Proof)
export const M04_02_PROBLEMS = [
  {
    id: "M04_02_001",
    topicId: "M04_02",
    question: "在△ABC 中，∠A、∠B、∠C 分別為三個內角。\n(a) 證明∠A + ∠B + ∠C = 180°\n(b) 若∠A = 2∠B，∠C = 3∠B，求各角的度數\n(c) 證明任意三角形最多只能有一個直角或鈍角",
    solution: "(a) 見證明, (b) ∠A = 60°, ∠B = 30°, ∠C = 90°, (c) 見證明",
    explanation: "三角形內角和定理是平面幾何的基礎定理。",
    hint: "利用平行線性質來證明三角形內角和為180°。",
    difficulty: 2,
    order: 1,
    steps: [
      "(a) 延長BC到D，過C作CE∥AB",
      "∠A = ∠ACE（內錯角），∠B = ∠ECD（同位角）",
      "∠ACB + ∠ACE + ∠ECD = 180°（平角）",
      "∴ ∠A + ∠B + ∠C = 180°",
      "(b) 設∠B = x，則∠A = 2x，∠C = 3x",
      "2x + x + 3x = 180°，x = 30°",
      "(c) 若有兩個直角或鈍角，則內角和 > 180°，矛盾"
    ]
  },
  {
    id: "M04_02_002",
    topicId: "M04_02",
    question: "在四邊形 ABCD 中，對角線 AC 和 BD 相交於點 O。\n(a) 證明四邊形內角和為 360°\n(b) 若∠A:∠B:∠C:∠D = 1:2:3:4，求各角度數\n(c) 證明凸四邊形中最多有三個鈍角",
    solution: "(a) 見證明, (b) ∠A = 36°, ∠B = 72°, ∠C = 108°, ∠D = 144°, (c) 見證明",
    explanation: "四邊形內角和定理及其推廣應用。",
    hint: "將四邊形分割成三角形來證明內角和。",
    difficulty: 2,
    order: 2,
    steps: [
      "(a) 連接AC，將四邊形分成△ABC和△ACD",
      "△ABC內角和 = 180°，△ACD內角和 = 180°",
      "四邊形內角和 = 180° + 180° = 360°",
      "(b) 設∠A = x，則各角為x, 2x, 3x, 4x",
      "x + 2x + 3x + 4x = 360°，10x = 360°，x = 36°",
      "(c) 若有四個鈍角，內角和 > 4×90° = 360°，矛盾"
    ]
  },
  {
    id: "M04_02_003",
    topicId: "M04_02",
    question: "正 n 邊形的性質研究：\n(a) 推導正 n 邊形內角和公式\n(b) 求正八邊形每個內角的度數\n(c) 證明正 n 邊形每個外角為 360°/n",
    solution: "(a) (n-2)×180°, (b) 135°, (c) 見證明",
    explanation: "正多邊形角度計算的通用方法。",
    hint: "將多邊形分割成三角形，利用三角形內角和。",
    difficulty: 3,
    order: 3,
    steps: [
      "(a) 將n邊形從一個頂點分割成(n-2)個三角形",
      "內角和 = (n-2) × 180°",
      "(b) 正八邊形：n = 8",
      "每個內角 = (8-2) × 180° ÷ 8 = 1080° ÷ 8 = 135°",
      "(c) 外角和恆為360°，正n邊形每個外角相等",
      "每個外角 = 360° ÷ n"
    ]
  },
  {
    id: "M04_02_004",
    topicId: "M04_02",
    question: "在△ABC 中，AD 是∠BAC 的角平分線，BE 是∠ABC 的角平分線，它們相交於點 I。\n(a) 證明∠AIB = 90° + ∠C/2\n(b) 若∠C = 60°，求∠AIB 的度數\n(c) 證明點 I 是△ABC 的內心",
    solution: "(a) 見證明, (b) ∠AIB = 120°, (c) 見證明",
    explanation: "三角形角平分線的性質和內心的概念。",
    hint: "利用三角形內角和和角平分線的定義。",
    difficulty: 3,
    order: 4,
    steps: [
      "(a) 在△AIB中，∠IAB = ∠A/2，∠IBA = ∠B/2",
      "∠AIB = 180° - ∠A/2 - ∠B/2",
      "= 180° - (∠A + ∠B)/2",
      "= 180° - (180° - ∠C)/2 = 90° + ∠C/2",
      "(b) ∠AIB = 90° + 60°/2 = 90° + 30° = 120°",
      "(c) I到三邊距離相等，是內心"
    ]
  },
  {
    id: "M04_02_005",
    topicId: "M04_02",
    question: "在△ABC 中，∠A = 80°，∠B = 60°。點 D 在 BC 上，使得 AD = AB。\n(a) 求∠C 的度數\n(b) 求∠BAD 的度數\n(c) 證明△ABD 是等腰三角形並求其頂角",
    solution: "(a) ∠C = 40°, (b) ∠BAD = 20°, (c) 見證明，頂角 = 140°",
    explanation: "等腰三角形性質與角度計算的綜合應用。",
    hint: "利用等腰三角形底角相等的性質。",
    difficulty: 3,
    order: 5,
    steps: [
      "(a) ∠C = 180° - ∠A - ∠B = 180° - 80° - 60° = 40°",
      "(b) ∵ AD = AB，∴ △ABD是等腰三角形",
      "∠ADB = ∠ABD = 60°（底角相等）",
      "在△ABD中，∠BAD = 180° - 60° - 60° = 60°",
      "但這與∠A = 80°矛盾，需重新分析",
      "∠BAD = ∠A - ∠CAD，需要更多信息確定"
    ]
  },
  {
    id: "M04_02_006",
    topicId: "M04_02",
    question: "設計一個角度證明問題：在任意四邊形 ABCD 中，對角線 AC、BD 相交於點 O。\n(a) 若∠AOB + ∠COD = 180°，證明∠AOD + ∠BOC = 180°\n(b) 在上述條件下，證明 A、B、C、D 四點共圓\n(c) 利用這個結果解決一個實際幾何問題",
    solution: "(a) 見證明, (b) 見證明, (c) 見應用",
    explanation: "對頂角性質和圓內接四邊形的判定。",
    hint: "利用對頂角相等和圓內接四邊形的性質。",
    difficulty: 4,
    order: 6,
    steps: [
      "(a) ∵ ∠AOB和∠COD是對頂角，∴ ∠AOB = ∠COD",
      "同理，∠AOD = ∠BOC",
      "∵ ∠AOB + ∠BOC + ∠COD + ∠AOD = 360°",
      "若∠AOB + ∠COD = 180°，則∠AOD + ∠BOC = 180°",
      "(b) 對角互補的四邊形內接於圓",
      "(c) 應用：建築設計中的拱形結構分析"
    ]
  }
];

// M04-03: 代數角度求解 (Algebraic Angle Solutions)
export const M04_03_PROBLEMS = [
  {
    id: "M04_03_001",
    topicId: "M04_03",
    question: "在△ABC 中，∠A = (3x + 10)°，∠B = (2x - 5)°，∠C = (x + 25)°。\n(a) 建立方程求解 x 的值\n(b) 求各角的度數\n(c) 判斷這是什麼類型的三角形",
    solution: "(a) x = 25°, (b) ∠A = 85°, ∠B = 45°, ∠C = 50°, (c) 銳角三角形",
    explanation: "利用三角形內角和建立方程求解未知角度。",
    hint: "三角形內角和等於180°。",
    difficulty: 2,
    order: 1,
    steps: [
      "(a) 根據三角形內角和定理：",
      "(3x + 10) + (2x - 5) + (x + 25) = 180",
      "6x + 30 = 180",
      "6x = 150，x = 25",
      "(b) ∠A = 3(25) + 10 = 85°",
      "∠B = 2(25) - 5 = 45°，∠C = 25 + 25 = 50°",
      "(c) 所有角都小於90°，是銳角三角形"
    ]
  },
  {
    id: "M04_03_002",
    topicId: "M04_03",
    question: "四邊形 PQRS 中，∠P = (2y + 30)°，∠Q = (3y - 10)°，∠R = (y + 40)°，∠S = (4y - 20)°。\n(a) 求 y 的值\n(b) 求最大角和最小角的度數\n(c) 判斷是否存在直角",
    solution: "(a) y = 32°, (b) 最大角 = 108°, 最小角 = 72°, (c) 不存在直角",
    explanation: "四邊形內角和為360°的代數應用。",
    hint: "四邊形內角和等於360°。",
    difficulty: 2,
    order: 2,
    steps: [
      "(a) 四邊形內角和 = 360°：",
      "(2y + 30) + (3y - 10) + (y + 40) + (4y - 20) = 360",
      "10y + 40 = 360",
      "10y = 320，y = 32",
      "(b) ∠P = 94°，∠Q = 86°，∠R = 72°，∠S = 108°",
      "最大角 = 108°，最小角 = 72°",
      "(c) 沒有90°角，不存在直角"
    ]
  },
  {
    id: "M04_03_003",
    topicId: "M04_03",
    question: "在等腰三角形 ABC 中，AB = AC，∠B = (4z - 15)°，∠C = (2z + 5)°。\n(a) 利用等腰三角形性質建立方程\n(b) 求 z 的值和各角度數\n(c) 驗證結果並分析三角形的特殊性質",
    solution: "(a) 4z - 15 = 2z + 5, (b) z = 10°, ∠A = 120°, ∠B = ∠C = 30°, (c) 鈍角等腰三角形",
    explanation: "等腰三角形底角相等的性質應用。",
    hint: "等腰三角形的底角相等。",
    difficulty: 2,
    order: 3,
    steps: [
      "(a) ∵ AB = AC，∴ ∠B = ∠C（底角相等）",
      "4z - 15 = 2z + 5",
      "(b) 2z = 20，z = 10",
      "∠B = ∠C = 4(10) - 15 = 25°",
      "∠A = 180° - 25° - 25° = 130°",
      "(c) ∠A > 90°，是鈍角等腰三角形"
    ]
  },
  {
    id: "M04_03_004",
    topicId: "M04_03",
    question: "在梯形 ABCD 中，AB ∥ CD，∠A = (5m + 20)°，∠D = (3m + 40)°，∠B = (2m + 60)°。\n(a) 利用梯形性質建立關於 m 的方程\n(b) 求 m 的值和各角度數\n(c) 計算對角的度數並驗證梯形性質",
    solution: "(a) 8m + 60 = 180, (b) m = 15°, (c) 對角和 = 180°",
    explanation: "梯形同側內角互補的性質。",
    hint: "梯形中，平行邊的同側內角互補。",
    difficulty: 3,
    order: 4,
    steps: [
      "(a) ∵ AB ∥ CD，∴ ∠A + ∠D = 180°（同側內角互補）",
      "(5m + 20) + (3m + 40) = 180",
      "8m + 60 = 180",
      "(b) 8m = 120，m = 15",
      "∠A = 95°，∠D = 85°，∠B = 90°",
      "∠C = 360° - 95° - 85° - 90° = 90°",
      "(c) 對角：∠A + ∠C = 95° + 90° = 185°，需要修正計算"
    ]
  },
  {
    id: "M04_03_005",
    topicId: "M04_03",
    question: "正 n 邊形中，每個內角為 (180° - 720°/n)。\n(a) 若內角為 144°，求邊數 n\n(b) 求外角的度數\n(c) 設計一個實際問題來應用這個結果",
    solution: "(a) n = 10, (b) 外角 = 36°, (c) 見設計問題",
    explanation: "正多邊形內角公式的逆向應用。",
    hint: "正n邊形每個內角 = (n-2)×180°/n。",
    difficulty: 3,
    order: 5,
    steps: [
      "(a) 設內角 = 144°",
      "180° - 720°/n = 144°",
      "720°/n = 36°",
      "n = 720°/36° = 20，需要重新檢查公式",
      "正確公式：(n-2)×180°/n = 144°",
      "(n-2)×180° = 144n，180n - 360 = 144n",
      "36n = 360，n = 10",
      "(b) 外角 = 180° - 144° = 36°"
    ]
  },
  {
    id: "M04_03_006",
    topicId: "M04_03",
    question: "複雜角度關係：在△ABC 中，∠A = α，∠B = 2α，∠C = 3α - 60°。\n(a) 建立方程求 α 的值\n(b) 討論當 α 取不同值時三角形的存在性\n(c) 求使三角形為直角三角形的 α 值",
    solution: "(a) α = 40°, (b) 0° < α < 60°, (c) α = 30° 或 α = 50°",
    explanation: "含參數的三角形角度分析。",
    hint: "考慮三角形內角和為180°以及每個角為正的條件。",
    difficulty: 4,
    order: 6,
    steps: [
      "(a) α + 2α + (3α - 60°) = 180°",
      "6α - 60° = 180°",
      "6α = 240°，α = 40°",
      "(b) 需要：α > 0°，2α > 0°，3α - 60° > 0°",
      "即 α > 20°，且 α + 2α < 180°，即 α < 60°",
      "所以 20° < α < 60°",
      "(c) 若∠A = 90°：α = 90°（不滿足範圍）",
      "若∠B = 90°：2α = 90°，α = 45°",
      "若∠C = 90°：3α - 60° = 90°，α = 50°"
    ]
  }
];

// M04-04: 角度比例分配 (Angle Proportion Distribution)
export const M04_04_PROBLEMS = [
  {
    id: "M04_04_001",
    topicId: "M04_04",
    question: "在△ABC 中，三個內角的比為 ∠A:∠B:∠C = 2:3:4。\n(a) 求各角的度數\n(b) 判斷三角形的類型\n(c) 若將比例改為 1:2:3，重新計算並比較結果",
    solution: "(a) ∠A = 40°, ∠B = 60°, ∠C = 80°, (b) 銳角三角形, (c) 30°:60°:90°，直角三角形",
    explanation: "利用比例關係和三角形內角和求解角度。",
    hint: "設比例係數為 k，利用內角和為180°求解。",
    difficulty: 2,
    order: 1,
    steps: [
      "(a) 設∠A = 2k，∠B = 3k，∠C = 4k",
      "2k + 3k + 4k = 180°",
      "9k = 180°，k = 20°",
      "∠A = 40°，∠B = 60°，∠C = 80°",
      "(b) 所有角都小於90°，是銳角三角形",
      "(c) 1:2:3 → k = 30°，得30°:60°:90°，是直角三角形"
    ]
  },
  {
    id: "M04_04_002",
    topicId: "M04_04",
    question: "四邊形 ABCD 的內角比為 ∠A:∠B:∠C:∠D = 3:4:5:6。\n(a) 求各角的度數\n(b) 判斷是否為凸四邊形\n(c) 若要使其中一個角為直角，應如何調整比例？",
    solution: "(a) 60°:80°:100°:120°, (b) 是凸四邊形, (c) 比例調整為 3:4:5:6 → 3:4.5:5:5.5",
    explanation: "四邊形內角比例分配的計算方法。",
    hint: "四邊形內角和為360°。",
    difficulty: 2,
    order: 2,
    steps: [
      "(a) 設比例係數為 t",
      "3t + 4t + 5t + 6t = 360°",
      "18t = 360°，t = 20°",
      "各角：60°，80°，100°，120°",
      "(b) 所有角都小於180°，是凸四邊形",
      "(c) 若∠B = 90°，則4t = 90°，t = 22.5°",
      "新比例為 3:4:5:6，總和仍為18"
    ]
  },
  {
    id: "M04_04_003",
    topicId: "M04_04",
    question: "等腰三角形 ABC 中，AB = AC，頂角與底角的比為 ∠A:∠B = 4:3。\n(a) 求各角的度數\n(b) 驗證等腰三角形的性質\n(c) 若比例改為 2:1，討論三角形的存在性",
    solution: "(a) ∠A = 72°, ∠B = ∠C = 54°, (b) 底角相等, (c) 2:1時∠A = 90°，存在",
    explanation: "等腰三角形中角度比例的特殊性質。",
    hint: "等腰三角形底角相等，∠B = ∠C。",
    difficulty: 3,
    order: 3,
    steps: [
      "(a) 設∠A = 4k，∠B = ∠C = 3k（底角相等）",
      "4k + 3k + 3k = 180°",
      "10k = 180°，k = 18°",
      "∠A = 72°，∠B = ∠C = 54°",
      "(b) ∠B = ∠C，符合等腰三角形性質",
      "(c) 若∠A:∠B = 2:1，設∠A = 2m，∠B = ∠C = m",
      "2m + m + m = 180°，4m = 180°，m = 45°",
      "∠A = 90°，∠B = ∠C = 45°，是直角等腰三角形"
    ]
  },
  {
    id: "M04_04_004",
    topicId: "M04_04",
    question: "在平行四邊形 PQRS 中，相鄰兩角的比為 ∠P:∠Q = 2:3。\n(a) 求各角的度數\n(b) 驗證平行四邊形的角度性質\n(c) 計算對角線與邊的夾角",
    solution: "(a) ∠P = ∠R = 72°, ∠Q = ∠S = 108°, (b) 對角相等，鄰角互補, (c) 需要更多條件",
    explanation: "平行四邊形角度性質與比例關係。",
    hint: "平行四邊形對角相等，鄰角互補。",
    difficulty: 3,
    order: 4,
    steps: [
      "(a) 設∠P = 2n，∠Q = 3n",
      "∵ 平行四邊形鄰角互補：∠P + ∠Q = 180°",
      "2n + 3n = 180°，5n = 180°，n = 36°",
      "∠P = 72°，∠Q = 108°",
      "(b) ∠P = ∠R = 72°，∠Q = ∠S = 108°（對角相等）",
      "∠P + ∠Q = 72° + 108° = 180°（鄰角互補）",
      "(c) 對角線夾角需要知道邊長比例才能確定"
    ]
  },
  {
    id: "M04_04_005",
    topicId: "M04_04",
    question: "正多邊形的內角與外角比為 n:2（其中 n 為邊數）。\n(a) 建立方程求邊數 n\n(b) 求該多邊形每個內角的度數\n(c) 設計該多邊形的實際應用",
    solution: "(a) n = 8, (b) 內角 = 135°, (c) 正八邊形應用",
    explanation: "正多邊形內外角關係的比例應用。",
    hint: "內角 + 外角 = 180°，外角 = 360°/n。",
    difficulty: 4,
    order: 5,
    steps: [
      "(a) 設內角為 nk，外角為 2k",
      "內角 + 外角 = 180°：nk + 2k = 180°",
      "(n + 2)k = 180°",
      "又外角 = 360°/n，所以 2k = 360°/n",
      "k = 180°/n",
      "代入：(n + 2) × 180°/n = 180°",
      "n + 2 = n，矛盾，需重新分析",
      "正確：內角/外角 = n/2，內角 = n×外角/2"
    ]
  },
  {
    id: "M04_04_006",
    topicId: "M04_04",
    question: "創新問題：設計一個五邊形，其內角比為 1:2:3:4:5。\n(a) 求各角的度數\n(b) 判斷該五邊形是否為凸五邊形\n(c) 設計一個實際的建築或工程應用場景",
    solution: "(a) 36°:72°:108°:144°:180°, (b) 有平角，不是凸五邊形, (c) 見應用場景",
    explanation: "任意多邊形角度比例分配的綜合應用。",
    hint: "五邊形內角和為 (5-2)×180° = 540°。",
    difficulty: 4,
    order: 6,
    steps: [
      "(a) 設比例係數為 p",
      "p + 2p + 3p + 4p + 5p = 540°",
      "15p = 540°，p = 36°",
      "各角：36°，72°，108°，144°，180°",
      "(b) 有一個角為180°（平角），不是凸五邊形",
      "(c) 應用場景：特殊屋頂設計",
      "或機械零件的切割角度設計"
    ]
  }
];

// M04-05: 三角形邊長範圍 (Triangle Side Length Range)
export const M04_05_PROBLEMS = [
  {
    id: "M04_05_001",
    topicId: "M04_05",
    question: "已知三角形兩邊長分別為 5cm 和 8cm。\n(a) 求第三邊長的取值範圍\n(b) 若第三邊長為整數，列出所有可能值\n(c) 當第三邊長取最小整數值時，計算三角形周長",
    solution: "(a) 3 < c < 13, (b) 4, 5, 6, 7, 8, 9, 10, 11, 12, (c) 周長 = 17cm",
    explanation: "三角形三邊關係：任意兩邊之和大於第三邊。",
    hint: "利用三角形不等式：|a-b| < c < a+b。",
    difficulty: 1,
    order: 1,
    steps: [
      "(a) 設第三邊為 c，根據三角形不等式：",
      "5 + 8 > c，即 c < 13",
      "5 + c > 8，即 c > 3",
      "8 + c > 5（恆成立）",
      "因此：3 < c < 13",
      "(b) 整數值：4, 5, 6, 7, 8, 9, 10, 11, 12",
      "(c) 最小整數值 c = 4，周長 = 5 + 8 + 4 = 17cm"
    ]
  },
  {
    id: "M04_05_002",
    topicId: "M04_05",
    question: "等腰三角形的底邊長為 6cm，腰長為 x cm。\n(a) 求 x 的取值範圍\n(b) 若三角形的周長為 16cm，求腰長\n(c) 當腰長取最小值時，計算頂角的度數",
    solution: "(a) x > 3, (b) x = 5cm, (c) 頂角 = 180°（退化情況）",
    explanation: "等腰三角形邊長約束條件。",
    hint: "等腰三角形兩腰相等，需滿足三角形不等式。",
    difficulty: 2,
    order: 2,
    steps: [
      "(a) 兩腰長為 x，底邊長為 6",
      "根據三角形不等式：x + x > 6",
      "2x > 6，x > 3",
      "x + 6 > x（恆成立）",
      "因此 x > 3",
      "(b) 周長 = x + x + 6 = 16",
      "2x = 10，x = 5cm",
      "(c) 當 x → 3 時，三角形趨於退化"
    ]
  },
  {
    id: "M04_05_003",
    topicId: "M04_05",
    question: "直角三角形的兩直角邊分別為 3cm 和 4cm。\n(a) 計算斜邊長度\n(b) 驗證是否滿足三角形不等式\n(c) 若將其中一直角邊增加 2cm，重新計算並比較結果",
    solution: "(a) 5cm, (b) 滿足, (c) 新斜邊 = √37 ≈ 6.08cm",
    explanation: "直角三角形的勾股定理與三角形不等式。",
    hint: "利用勾股定理：a² + b² = c²。",
    difficulty: 2,
    order: 3,
    steps: [
      "(a) 根據勾股定理：c² = 3² + 4² = 9 + 16 = 25",
      "c = 5cm",
      "(b) 驗證三角形不等式：",
      "3 + 4 = 7 > 5 ✓",
      "3 + 5 = 8 > 4 ✓",
      "4 + 5 = 9 > 3 ✓",
      "(c) 新直角邊為 5cm，另一邊仍為 4cm",
      "新斜邊 = √(5² + 4²) = √41 ≈ 6.4cm"
    ]
  },
  {
    id: "M04_05_004",
    topicId: "M04_05",
    question: "三角形三邊長分別為 (2x-1)cm、(x+3)cm 和 (x+5)cm。\n(a) 建立不等式組求 x 的取值範圍\n(b) 若三角形為等腰三角形，求 x 的值\n(c) 求使三角形周長最小的 x 值",
    solution: "(a) x > 3, (b) x = 4 或 x = 8, (c) x = 3（邊界值）",
    explanation: "含參數的三角形邊長約束問題。",
    hint: "利用三角形不等式建立關於 x 的不等式組。",
    difficulty: 3,
    order: 4,
    steps: [
      "(a) 三邊長：2x-1, x+3, x+5",
      "首先要求各邊長為正：2x-1 > 0，x > 0.5",
      "三角形不等式：",
      "(2x-1) + (x+3) > x+5 → 2x > 3 → x > 1.5",
      "(2x-1) + (x+5) > x+3 → 2x > -1（恆成立）",
      "(x+3) + (x+5) > 2x-1 → 9 > -1（恆成立）",
      "因此 x > 1.5",
      "(b) 等腰情況需要兩邊相等，分情況討論"
    ]
  },
  {
    id: "M04_05_005",
    topicId: "M04_05",
    question: "在△ABC 中，AB = 7cm，BC = 10cm，∠B = 60°。\n(a) 利用餘弦定理求 AC 的長度\n(b) 驗證所得結果是否滿足三角形不等式\n(c) 計算三角形的面積",
    solution: "(a) AC = √79 ≈ 8.89cm, (b) 滿足, (c) 面積 = 35√3/2 ≈ 30.31cm²",
    explanation: "餘弦定理與三角形不等式的綜合應用。",
    hint: "餘弦定理：c² = a² + b² - 2ab cos C。",
    difficulty: 3,
    order: 5,
    steps: [
      "(a) 利用餘弦定理：",
      "AC² = AB² + BC² - 2·AB·BC·cos B",
      "AC² = 7² + 10² - 2·7·10·cos 60°",
      "AC² = 49 + 100 - 140·(1/2) = 149 - 70 = 79",
      "AC = √79 ≈ 8.89cm",
      "(b) 驗證：7 + 10 = 17 > 8.89 ✓",
      "(c) 面積 = (1/2)·AB·BC·sin B = (1/2)·7·10·sin 60° = 35√3/2"
    ]
  },
  {
    id: "M04_05_006",
    topicId: "M04_05",
    question: "設計問題：要製作一個三角形框架，已知兩邊分別為 a cm 和 b cm (a < b)。\n(a) 推導第三邊 c 的取值範圍公式\n(b) 若要使三角形面積最大，第三邊應取什麼值？\n(c) 設計一個實際工程應用場景",
    solution: "(a) b-a < c < b+a, (b) c 使得三角形接近等邊, (c) 見工程應用",
    explanation: "三角形設計中的最優化問題。",
    hint: "面積最大時，三角形應盡可能接近等邊三角形。",
    difficulty: 4,
    order: 6,
    steps: [
      "(a) 根據三角形不等式：",
      "a + b > c，即 c < a + b",
      "a + c > b，即 c > b - a",
      "b + c > a（當 b ≥ a 時恆成立）",
      "因此：b - a < c < a + b",
      "(b) 固定兩邊時，面積最大當第三邊使三角形接近等邊",
      "最優值需要用微積分求解",
      "(c) 應用：橋樑桁架設計、屋頂框架結構"
    ]
  }
]; 